/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DetailedShipmentReport } from "./DetailedShipmentReport";
import {
  DetailedShipmentReportFromJSON,
  DetailedShipmentReportFromJSONTyped,
  DetailedShipmentReportToJSON,
  DetailedShipmentReportToJSONTyped,
} from "./DetailedShipmentReport";

/**
 *
 * @export
 * @interface AllShipmentsPage
 */
export interface AllShipmentsPage {
  /**
   *
   * @type {Array<DetailedShipmentReport>}
   * @memberof AllShipmentsPage
   */
  rows: Array<DetailedShipmentReport>;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsPage
   */
  totalCount: number;
}

/**
 * Check if a given object implements the AllShipmentsPage interface.
 */
export function instanceOfAllShipmentsPage(
  value: object,
): value is AllShipmentsPage {
  if (!("rows" in value) || value["rows"] === undefined) return false;
  if (!("totalCount" in value) || value["totalCount"] === undefined)
    return false;
  return true;
}

export function AllShipmentsPageFromJSON(json: any): AllShipmentsPage {
  return AllShipmentsPageFromJSONTyped(json, false);
}

export function AllShipmentsPageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AllShipmentsPage {
  if (json == null) {
    return json;
  }
  return {
    rows: (json["rows"] as Array<any>).map(DetailedShipmentReportFromJSON),
    totalCount: json["totalCount"],
  };
}

export function AllShipmentsPageToJSON(json: any): AllShipmentsPage {
  return AllShipmentsPageToJSONTyped(json, false);
}

export function AllShipmentsPageToJSONTyped(
  value?: AllShipmentsPage | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    rows: (value["rows"] as Array<any>).map(DetailedShipmentReportToJSON),
    totalCount: value["totalCount"],
  };
}
